// extracted by mini-css-extract-plugin
module.exports = {"theme--dark-green":"DateText_theme--dark-green__v_QBc","container":"DateText_container__mqoHf","date":"DateText_date__OLHMT"};